import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ProdutoCard, MetodoCard } from '@core/models/produto.models';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DetalheProdutoComponent } from '../detalhe-produto/detalhe-produto.component';
import { AuthenticationService } from '@core/auth/authentication.service';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as star } from '@fortawesome/free-regular-svg-icons';
import { NotificationService } from '@core/services/notification.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TipoProdutoEnum } from '@core/models/tipo-produto.models';
import { MetodoEnum } from '@core/models/metodo.models';
import { AppSharedDataService } from 'src/app/app-shared-data.service';
import { SivveService } from '@core/services/sivve.service';
import { DashboardService } from '@core/services/dashboard.service';
import { EStorage } from '@shared/utils/enums/storage.enum';
import { StorageService } from '@shared/utils/services/storage.service';
import { IRamos, RamosMenuEnum } from '@core/models/ramo.models';

@Component({
  selector: 'card-produto',
  templateUrl: './card-produto.component.html',
  styleUrls: ['./card-produto.component.scss']
})
export class CardProdutoComponent implements OnInit {

  @Input() produto: ProdutoCard;
  @Input() idRamo: number;
  @Output() onFavorite = new EventEmitter<number>();
  @Output() onDesFavorite = new EventEmitter<number>();

  favorito = faStar;
  naoFavorito = star;
  hover: boolean;
  modal: any;
  itensMenuPbi: any[] = [];
  itensMenuDBAntifraude: any[] = [];
  itensMenuDBSti: any[] = [];
  menuCompleto: IRamos[] = []
  dashboardBiEnum = DashboardBiEnum;
  subItensDashboardBi: any[] = [];
  subItensDashboardBiSti: any[] = [];
  subItensDashboardBiSia: any[] = [];
  subItensDashboardBiPc: any[] = [];
  ramoEnum = RamosMenuEnum
  itensMenuDBSia: any[] = [];
  itensMenuGrupoSti: any[] = [];
  itensMenuComissaoSti: any[] = [];
  iconesRamo = {
    [RamosMenuEnum.Automovel]: 'automovel',
    [RamosMenuEnum.Habitacional]: 'habitacional',
    [RamosMenuEnum.Multiramo]: 'multiramo',
    [RamosMenuEnum.Saude]: 'saude',
    [RamosMenuEnum.Previdencia]: 'previdencia',
    [RamosMenuEnum.Vida]: 'vida',
    [RamosMenuEnum.Transporte]: 'transporte',
    [RamosMenuEnum.Antifraude]: 'antifraude'
  }

  constructor(private router: Router,
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private _sanitizer: DomSanitizer,
    private appSharedDataService: AppSharedDataService,
    private sivveService: SivveService,
    private dashboardService: DashboardService,
    private _storageService: StorageService,
    private storageService: StorageService) {
  }

  ngOnInit() {
    if (this.produto.metodos) {
      let produtosSivve = this.produto.metodos.filter(x => [MetodoEnum.SivvePlusCPF, MetodoEnum.SivvePlusCNPJ, MetodoEnum.ConsultaAvancada].indexOf(x.id) != -1);
      produtosSivve = produtosSivve.concat(this.produto.metodos.filter(x => [MetodoEnum.SivveQuadroPessoalV2].indexOf(x.id) != -1));
      if (produtosSivve.length) {
        this.produto.metodos = produtosSivve.concat(this.produto.metodos.filter(x => [MetodoEnum.SivvePlusCPF, MetodoEnum.SivvePlusCNPJ, MetodoEnum.ConsultaAvancada, MetodoEnum.SivveQuadroPessoalV2].indexOf(x.id) == -1))
        this.produto.metodos.filter(x => x.id == MetodoEnum.ConsultaAvancada && !x.acesso);
      }
    }

    this.itensMenuPbi = this.dashboardService.powerBiMenu
    this.itensMenuDBAntifraude = this.dashboardService.dashboardAntifraudeMenu;
    this.itensMenuDBSia = this.dashboardService.dashboardSiaMenu;
    this.itensMenuDBSti = this.dashboardService.dashboardStiMenu;
    this.itensMenuGrupoSti = this.dashboardService.grupoAssinaturasStiMenu;
    this.itensMenuComissaoSti = this.dashboardService.comissaoStiMenu;

    switch (this.produto.idProduto) {
      case this.dashboardBiEnum.DashboardBiSti:
        for (let metodo of this.dashboardService.dashboardStiMenu) {
          this.subItensDashboardBiSti.push(metodo.subItem)
        }
      case this.dashboardBiEnum.DashboardBiSia:
        this.subItensDashboardBiSia = this.dashboardService.dashboardSiaMenu[0].subItem;
      case this.dashboardBiEnum.DashboardBiProcedimentosCriminais:
        this.subItensDashboardBiPc = this.dashboardService.dashboardAntifraudeMenu[0].subItem;
    }
  }


  favorite(): void {
    this.onFavorite.emit(this.produto.idProduto);
  }

  desfavorite(): void {
    this.onDesFavorite.emit(this.produto.idProduto);
  }

  goToConsulta(produto: any, metodo: any, subItem?: any): void {

    let metodoId = metodo.id
    let dsMetodo = metodo.dsMetodo

    if (produto.idProduto == 80 && metodo) {
      let reportNamePBI = this.itensMenuPbi.find((x: any) => x.id == metodo.id);
      sessionStorage.setItem('reportNamePBI', reportNamePBI.subItem[0].nameReport);
    }
    if (produto.idProduto == 85 && metodo) {
      sessionStorage.setItem('reportNameDBAntifraude', subItem.nameReport);
    }

    if (produto.idProduto == 106 && metodo) {
      metodoId = subItem.nameReport
      sessionStorage.setItem('reportNameDBSti', subItem.nameReport);
    }

    if (produto.idProduto == 107 && metodo) {
      let reportNamePBI = this.itensMenuDBSti.find((x: any) => x.id == metodo.id);
      sessionStorage.setItem('reportNameDBSia', subItem.link);
    }

    if (this.produto.acesso && metodo.acesso) {

      const storageMenuValue = this._storageService.get({ storageKey: EStorage.MENU })
      let ramos: any[]
      let ramoId: string
      if (storageMenuValue) {
        ramos = storageMenuValue.value
      }

      for (let ramo of ramos) {
        const foundRamo = ramo?.produtos.find(pdt => pdt.idProduto == produto.idProduto)
        if (foundRamo) ramoId = ramo.id
      }
      this.appSharedDataService.setMetodoAtivo({ ramo: ramoId, produto: this.produto, metodo: metodo });
      this.router.navigate(['/consulta', ramoId, this.produto.idProduto, metodoId, this.produto.dsServico, dsMetodo], { queryParamsHandling: 'merge', queryParams: { favorito: this.produto.favorito } });
      this.hover = false;
    }
    else
      this.notificationService.info('Você não possui permissão para realizar esta consulta!!!');
  }

  openInfo(): void {
    this.hover = true;
    this.modal = this.modalService.open(DetalheProdutoComponent, {
      keyboard: false,
      beforeDismiss: () => {
        return this.authenticationService.currentUserValue == null;
      },
      centered: true,
      windowClass: 'modal-detalhe-produto'
    });

    let instance = <DetalheProdutoComponent>this.modal.componentInstance;
    instance.descricao = this.produto.descricaoDetalhada;
    instance.nomeProduto = this.produto.nomeProduto;
    instance.icone = this.iconesRamo[this.idRamo];
    this.modal.result.then((data) => {
      this.hover = false;
      this.modal = undefined;
    })
  }

  saibaMais(): void {
    this.produto.urlExterna ? window.open(this.produto.urlExterna, '_blank') : this.openInfo();
  }

  onHover(): void {
    this.hover = true;
  }

  onLeave(): void {
    if (!this.modal)
      this.hover = false;
  }

  getImage() {
    return this._sanitizer.bypassSecurityTrustStyle(`url('${this.produto.imgProduto}')`);
  }

  get showMetodos() {
    return this.produto.idTipoProduto == TipoProdutoEnum.Padrao;
  }

  showMetodo(metodo): boolean {
    if (metodo.id == MetodoEnum.ConsultaAvancada && !metodo.acesso)
      return false;
    if ([2115, 2116, 2117, 2118, 2119, 2120, 2121, 2122, 2124, 2125, 2126, 2127, 2128, 2129, 10008, 10009, 10010, 10011, 10012, 10013, 10014, 10015, 10016, 10017].includes(metodo.id))
      return false;
    return true;
  }

  getAcessoSubItemSti(nameReport: string): boolean {
    const metodo = this.produto?.metodos?.find((m: any) => m.id == +nameReport);
    return metodo ? metodo.acesso : false;
  }

  hasGrupoSti(grupo: any): boolean {
    return grupo.subItem.some(ramo => this.produto?.metodos?.some((m: any) => m.id == +ramo.nameReport));
  }

  goToGrupoSti(ramo: any) {
    const metodo = this.produto?.metodos?.find((m: any) => m.id == +ramo.nameReport);
    if (!metodo) return

    sessionStorage.setItem('reportNameDBStiGrupo', ramo.subItem[0].link);
    this.goToConsulta(this.produto, metodo, ramo.subItem[0]);
  }

  goToComissao(pagina: any) {
    const metodo = this.produto?.metodos?.find((m: any) => m.id == +pagina.nameReport);
    if (!metodo) return

    this.goToConsulta(this.produto, metodo, pagina);
  }

  get showLinkExterno() {
    return this.produto.idTipoProduto == TipoProdutoEnum.LinkExterno;
  }

  goToLinkExterno(): void {
    if (!this.acesso)
      this.notificationService.info('Você não possui permissão para acessar este produto!!!');
  }

  goToForumSti(metodo: any) {
    metodo?.acesso ? window.open('https://sti.cnseg.org.br', '_blank') :
      this.notificationService.info('Você não possui permissão para acessar este produto!!!');
  }

  get acesso(): boolean {
    return this.produto.acesso || this.produto.idTipoProduto == TipoProdutoEnum.LinkExterno;
  }
}

export enum DashboardBiEnum {
  DashboardBiProcedimentosCriminais = 85,
  DashboardBiSti = 106,
  DashboardBiSia = 107
}
